/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FinanceSettingsUpdateEducationRequest
 */
export interface FinanceSettingsUpdateEducationRequest {
  /**
   *
   * @type {boolean}
   * @memberof FinanceSettingsUpdateEducationRequest
   */
  education: boolean;
}

export function FinanceSettingsUpdateEducationRequestFromJSON(json: any): FinanceSettingsUpdateEducationRequest {
  return FinanceSettingsUpdateEducationRequestFromJSONTyped(json, false);
}

export function FinanceSettingsUpdateEducationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinanceSettingsUpdateEducationRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    education: json["education"],
  };
}

export function FinanceSettingsUpdateEducationRequestToJSON(value?: FinanceSettingsUpdateEducationRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    education: value.education,
  };
}
